import {Component, inject, input, viewChild, signal, ChangeDetectionStrategy} from "@angular/core"
import {DefaultNode, NodesService} from "@node-editor/services/nodes.service"
import {SocketConnectionsService} from "@app/socket-editor/services/socket-connections.service"
import {Socket, SocketPosition} from "@socket-editor/types"
import {NodeSocketComponent} from "@app/socket-editor/components/node-socket/node-socket.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-node-io",
    imports: [],
    templateUrl: "./node-io.component.html",
    styleUrl: "./node-io.component.scss",
})
export class NodeIoComponent<NodeType extends DefaultNode> {
    readonly $nodeId = input.required<string>({alias: "nodeId"})
    readonly $socket = input.required<Socket>({alias: "socket"})
    readonly $socketComponent = viewChild.required<NodeSocketComponent>("socketComponent")

    readonly nodes = inject(NodesService<NodeType>)
    readonly connections = inject(SocketConnectionsService)

    readonly $connected = signal(false)

    getSocketPosition(): SocketPosition {
        return this.$socketComponent().getPosition()
    }
}
